<template>
  <main class="legal-document-page py-4 py-md-5">
    <b-container>
      <b-card class="legal-document-card mx-auto">
        <header class="legal-document-header">
          <div class="legal-document-navigation">
            <b-button
              variant="flat-primary"
              size="sm"
              @click="goBack"
            >
              ← Geri
            </b-button>
            <b-link :to="{ name: 'legal-hub' }">
              Tüm bilgilendirme metinleri
            </b-link>
          </div>
          <h1 class="h2 mt-2 mb-1">
            {{ document ? document.title : 'Belge bulunamadı' }}
          </h1>
          <p
            v-if="document && (document.version || document.effectiveAt)"
            class="text-muted"
          >
            <span v-if="document.version">Sürüm: {{ document.version }}</span>
            <span v-if="document.version && document.effectiveAt"> · </span>
            <span v-if="document.effectiveAt">Yürürlük: {{ document.effectiveAt }}</span>
          </p>
          <b-button
            v-if="contentComponent"
            class="print-button"
            variant="outline-primary"
            size="sm"
            @click="printDocument"
          >
            Yazdır
          </b-button>
        </header>

        <hr>

        <component
          :is="contentComponent"
          v-if="contentComponent"
          :document="document"
        />
        <b-alert
          v-else-if="document"
          show
          variant="warning"
        >
          {{ document.unavailableReason || 'Bu belge henüz yayımlanmadı.' }}
        </b-alert>
        <b-alert
          v-else
          show
          variant="danger"
        >
          İstenen bilgilendirme metni bulunamadı.
        </b-alert>
      </b-card>
    </b-container>
  </main>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BContainer,
  BLink,
} from 'bootstrap-vue'
import {
  getLegalDocumentBySlug,
  isPublishedLegalDocument,
} from '@/legal/documentRegistry'

const CONTENT_COMPONENTS = Object.freeze({
  MembershipAgreement: () => import('@/legal/documents/MembershipAgreement.vue'),
  MarketingConsent: () => import('@/legal/documents/MarketingConsent.vue'),
  SourceDocument: () => import('@/legal/documents/SourceDocument.vue'),
  WordDocument: () => import('@/legal/documents/WordDocument.vue'),
})

export default {
  name: 'LegalDocument',
  components: {
    BAlert,
    BButton,
    BCard,
    BContainer,
    BLink,
  },
  computed: {
    document() {
      return getLegalDocumentBySlug(this.$route.params.slug)
    },
    contentComponent() {
      if (!isPublishedLegalDocument(this.document)) return null
      return CONTENT_COMPONENTS[this.document.contentComponent] || null
    },
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
        return
      }
      this.$router.push({ name: 'legal-hub' })
    },
    printDocument() {
      window.print()
    },
  },
}
</script>

<style lang="scss">
.legal-document-page {
  min-height: calc(100vh - 86px);
  background: #f8f8fb;
}

.legal-document-card {
  max-width: 980px;
  border: 0;
  box-shadow: 0 6px 24px rgba(34, 41, 47, 0.08);
}

.legal-document-header {
  position: relative;
  padding-right: 6rem;
}

.legal-document-navigation {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.print-button {
  position: absolute;
  top: 0;
  right: 0;
}

@media (max-width: 575.98px) {
  .legal-document-header {
    padding-right: 0;
  }

  .print-button {
    position: static;
    margin-top: 0.75rem;
  }
}

@media print {
  .legal-document-page {
    padding: 0 !important;
    background: #fff;
  }

  .legal-document-header a,
  .legal-document-navigation,
  .print-button {
    display: none !important;
  }

  .legal-document-card {
    max-width: none;
    box-shadow: none;
  }
}

body.dark-layout {
  .legal-document-page {
    background: #161d31;
    color: #d0d2d6;
  }

  .legal-document-card {
    background: #283046;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.28);
  }

  .legal-document-card hr {
    border-top-color: #3b4253;
  }
}
</style>
